import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LocalStorageUtils } from "../helpers/LocalStorage";
import { BASE_URL } from "../constants/stringConstants";

export const TestCenterApi = createApi({
  reducerPath: "testCenter",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set("Accept", "application/json");
      // headers.set("Content-Type", "multipart/form-data");
      const token = LocalStorageUtils.getItem("auth_token");
      if (token && endpoint !== "/auth/login" && endpoint !== "/auth/signup") {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTestCenterList: builder.mutation<any, any>({
      query: ({ filterDetails }) => ({
        url: `test-logs?filter=${filterDetails}`,
        method: "GET",
      }),
    }),

    getTestQuestions: builder.mutation<any, any>({
      query: ({ id }) => ({
        url: `test-logs/${id}/candidate-tests`,
        method: "POST",
        body: {},
      }),
    }),

    getTestQuestionsPriority: builder.mutation<any, any>({
      query: ({ id }) => ({
        url: `tests/${id}/test-priority-questions`,
        method: "GET",
      }),
    }),

    submitTest: builder.mutation<any, any>({
      query: ({ id, data }) => ({
        url: `candidate-tests/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetTestCenterListMutation,
  useGetTestQuestionsMutation,
  useGetTestQuestionsPriorityMutation,
  useSubmitTestMutation,
} = TestCenterApi;

// 'https://123.123.123.123/goods/121'
